import * as Yup from "yup";

export const GET_BLOGS = "GET_BLOGS";
export const GET_BLOG_DETAILS = "GET_BLOG_DETAILS";
export const RESET_BLOG_DETAILS = "RESET_BLOG_DETAILS";
export const GET_META_TAGS = "GET_META_TAGS";
export const SET_BLOG_LIST_STATUS = "SET_BLOG_LIST_STATUS";
export const SET_BLOG_DETAIL_STATUS = "SET_BLOG_DETAIL_STATUS";
export const SET_HOME_MOSAIC_BLOGS = "SET_HOME_MOSAIC_BLOGS";
export const SET_FEATURED_BLOGS = "SET_FEATURED_BLOGS";
export const SET_TRENDING_BLOGS = "SET_TRENDING_BLOGS";
export const SET_FEATURED_TRENDING_BLOGS = "SET_FEATURED_TRENDING_BLOGS";
export const GET_BLOG_CATEGORY_AND_SUBCATEGORY = "GET_BLOG_CATEGORY_AND_SUBCATEGORY";
export const SET_SAVED_BLOGS = "SET_SAVED_BLOGS";

export const blogValidationSchema = Yup.object({
  blog_title: Yup.string().required("blog title can not be empty"),
  slug: Yup.string().required("Blog url can not be empty"),
  content_detail: Yup.string().required("content detail name can not be empty"),
  excerpt: Yup.string().required("excerpt can not be empty"),
  category_id: Yup.string().required("category can not be empty"),
  sub_category_id: Yup.string().required("sub category can not be empty"),
  author_id: Yup.string().required("author can not be empty"),
  blog_image: Yup.string().required("blog image can not be empty"),
  meta_title: Yup.string().required("meta title can not be empty"),
  meta_description: Yup.string().required("meta description can not be empty"),
  meta_keyword: Yup.string().required("meta keyword can not be empty"),
});

export const draftBlogValidationSchema = Yup.object({
  blog_title: Yup.string().required("blog title can not be empty"),
  category_id: Yup.string().required("category can not be empty"),
});

export enum filterTypes {
  blog_title = "blog_title",
  content_detail = "content_detail",
  source = "source",
  category_id = "category_id",
  blog_image = "blog_image",
  author_id = "author_id",
  reviewer_id = "reviewer_id",
  meta_tag = "meta_tag",
  publish = "publish",
  schedule_date_time = "schedule_date_time",
  meta_title = "meta_title",
  meta_description = "meta_description",
  meta_keyword = "meta_keyword",
  homepage_mosaic = "homepage_mosaic",
  featured_blog = "featured_blog",
  trending_blog = "trending_blog",
  status = "status",
  sub_category_id = "sub_category_id",
}

export const blogSlugs = {
  blogDetail: (slug: string) => `/blog/${slug}`,
  saveBlogPage: (page = 1) => `/blog/saved/page/${page}`,
};
